import { render, staticRenderFns } from "./tzsbjc.vue?vue&type=template&id=7ec5a88b&scoped=true"
import script from "./tzsbjc.vue?vue&type=script&lang=js"
export * from "./tzsbjc.vue?vue&type=script&lang=js"
import style0 from "./tzsbjc.vue?vue&type=style&index=0&id=7ec5a88b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec5a88b",
  null
  
)

export default component.exports